// src/components/Navbar.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import { logoutUser } from "../api/authService"; // ✅ centralized logout

const Navbar = () => {
  //const navigate = useNavigate();

  const handleLogout = () => {
    // ✅ Use shared logout logic from authService.js
    logoutUser();
    // navigate("/login");
    window.location.href = "/login";
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <h2 className="navbar-logo">🎓 Loyola eNotes</h2>
      </div>

      <div className="navbar-right">
        <ul className="navbar-links">
          <li><Link to="/dashboard">Dashboard</Link></li>
          <li><Link to="/departments">Departments</Link></li>
          <li><Link to="/programs">Programs</Link></li>
          <li><Link to="/add-unit">Add Unit</Link></li>
          <li><Link to="/add-lesson">Add Lesson</Link></li>
          <li>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

